module.exports = __webpack_public_path__ + "img/error.e008741b.svg";